import { render, staticRenderFns } from "./InvitePeopleModal.vue?vue&type=template&id=12609fc9&"
import script from "./InvitePeopleModal.vue?vue&type=script&lang=js&"
export * from "./InvitePeopleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports